var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimCard2Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2V18H14V5.82843L10.1716 2H2ZM1 0H11L15.7071 4.70711C15.8946 4.89464 16 5.149 16 5.41421V19C16 19.5523 15.5523 20 15 20H1C0.44772 20 0 19.5523 0 19V1C0 0.44772 0.44772 0 1 0ZM9 8V16H7V10H4V8H9ZM4 11H6V13H4V11ZM10 11H12V13H10V11ZM10 8H12V10H10V8ZM4 14H6V16H4V14ZM10 14H12V16H10V14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimCard2Line);
export default __webpack_public_path__ + "static/media/sim-card-2-line.8cbb62bc93e2eb71c77b9b1629bf162e.svg";
export { ForwardRef as ReactComponent };